// export const API_URL = "https://api.getfreadom.com/api/";

// const isProdEnv = () => ['web', 'staging'].includes(window.location?.hostname?.split('.')?.[0]);
const isProdEnv = () => window.location?.hostname?.split(".")?.[0];

export const API_URL =
  isProdEnv() === "web"
    ? "https://api.getfreadom.com/api/"
    : isProdEnv() === "staging"
    ? "https://dev-api-python-upgrade.getfreadom.com/api/"
      : "https://apicmseducation.getfreadom.com/api/";
      // : "http://127.0.0.1:8000/api/";

export const F_LIVE_API_URL =
  isProdEnv() === "web" || isProdEnv() === "staging"
    ? "https://apicmseducation.getfreadom.com/"
    : "https://apicmseducation.getfreadom.com/";

export const IRO_API_URL = "https://api.iro.getfreadom.com/api/";

export const IRO_FRONTEND_URL =
  isProdEnv() === "web"
    ? "https://iro.getfreadom.com"
    : isProdEnv() === "stage"
    ? "https://stage.iro.getfreadom.com"
    : "https://iro.getfreadom.com";

export const FRONTEND_URL =
  isProdEnv() === "web"
    ? "https://web.getfreadom.com"
    : isProdEnv() === "stage"
    ? "https://stage.web.getfreadom.com"
    : "https://cmseducation.getfreadom.com";
